import {
  DISABLE_PURCHASE_ORDER_ALERTS,
  DISABLE_PURCHASE_ORDER_ALERTS_ERROR,
  DISABLE_PURCHASE_ORDER_ALERTS_SUCCESS,
  CLEAN_ERRORS_PURCHASE_ORDER_STATUS,
  GET_PURCHASE_ORDER_STATUS,
  GET_PURCHASE_ORDER_STATUS_ERROR,
  GET_PURCHASE_ORDER_STATUS_SUCCESS,
  CHANGE_STATUS_PURCHASE_ORDER,
  CHANGE_STATUS_PURCHASE_ORDER_ERROR,
  CHANGE_STATUS_PURCHASE_ORDER_SUCCESS,
  SAVE_PURCHASE_ORDER_CODE
} from './PurchaseOrderStatus.actions'

const purchaseOrderState = {
  basicInfo: {},
  changeStatus: false,
  error: false,
  errors: [],
  loading: false,
  products: [],
  purchaseOrderCode: 0,
  swornDeclaration: {}
}

/**
 * The Purchase Order Status's reducer.
 */
const purchaseOrderStatusReducer = (state = purchaseOrderState, { payload, type }) => {
  switch (type) {
    case DISABLE_PURCHASE_ORDER_ALERTS: {
      return { ...state, loading: true, error: false }
    }
    case DISABLE_PURCHASE_ORDER_ALERTS_ERROR: {
      return { ...state, loading: false, error: true, errors: payload.errors }
    }
    case DISABLE_PURCHASE_ORDER_ALERTS_SUCCESS: {
      return { ...state, disablePurchaseOrderAlerts: payload }
    }
    case CLEAN_ERRORS_PURCHASE_ORDER_STATUS: {
      return { ...state, errors: [] }
    }
    case GET_PURCHASE_ORDER_STATUS: {
      return { ...state, loading: true, error: false }
    }
    case GET_PURCHASE_ORDER_STATUS_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case GET_PURCHASE_ORDER_STATUS_SUCCESS: {
      return {
        ...state,
        basicInfo: payload.basicInfo,
        products: payload.products,
        swornDeclaration: payload.swornDeclaration,
        loading: false,
        error: false
      }
    }
    case CHANGE_STATUS_PURCHASE_ORDER: {
      return { ...state, loading: true, error: false }
    }
    case CHANGE_STATUS_PURCHASE_ORDER_ERROR: {
      return { ...state, loading: false, error: true, errors: payload.errors }
    }
    case CHANGE_STATUS_PURCHASE_ORDER_SUCCESS: {
      return { ...state, changeStatus: payload }
    }
    case SAVE_PURCHASE_ORDER_CODE: {
      return { ...state, purchaseOrderCode: payload }
    }
    default: {
      return state
    }
  }
}

export default purchaseOrderStatusReducer
